module.exports = {
    "Clear search": `Po\u{10D}isti iskanje`
};


//# sourceMappingURL=sl-SI.main.js.map
